import './App.css';
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from './modules/HomePage/HomePage';
import { Layouts } from './components/Layout/index'; // Import Layouts component
import AboutUs from './modules/AboutUs/AboutUs';
import ContactUs from './modules/ContactUs/ContactUs'
import Services from './modules/Service/Service'
import Gallary from './modules/Gallery/Gallery';
import Portfolio from './modules/Portfolio/Portfolio'
import NotFound from './modules/NotFound/NotFound';
import Award from './modules/Award_CRS/Award_CRS'

const App = () => {
  return (
      <Routes>
        <Route path="/" element={<Layouts />}>
          <Route index element={<HomePage />} />
          <Route path='/about-us' element={<AboutUs />} />
          <Route path='/contact-us' element={<ContactUs />} />
          <Route path='/services' element={<Services />} />
          <Route path='/gallery' element={<Gallary />} />
          <Route path='/portfolio' element={<Portfolio />} />
          <Route path='/awards' element={<Award />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
  );
};

export default App;
